import { StepHeader } from "./components/StepHeader";
import React, { useState } from "react";
import { FullscreenModal } from "./components/FullscreenModal";
import { useSteps } from "./useSteps";
import checkPackagingIcon from "./images/check-packaging-icon.png";
import {
  WarehouseButtonsFooter,
  WarehouseButton,
  WarehouseButtonGroup,
} from "./components/WarehouseButtonsFooter";
import { CaptureDamagedPackagingPhotos } from "./CaptureDamagedPackagingPhotos";
import { createPortal } from "react-dom";
import { AnimatePresence } from "framer-motion";
import ExitModal from "./components/ExitModal";
import { useWarehouseContext } from "./WarehouseProvider";
import { useWarehouse } from "./useWarehouse";

const TITLE = "Check Packaging";

export const CheckPackaging = () => {
  const { clearTakeback } = useWarehouseContext();
  const { setRequiresBoxDamageEvidence, setHasCapturedBoxDamageEvidence } =
    useWarehouse();
  const { exit, next, jumpTo } = useSteps();
  const [showExitModal, setShowExitModal] = useState(false);

  const onCancel = () => {
    setShowExitModal(true);
  };

  const doExit = () => {
    clearTakeback();
    exit();
  };

  const handleDamagedPackaging = () => {
    setHasCapturedBoxDamageEvidence(false);
    setRequiresBoxDamageEvidence(true);
    jumpTo(CaptureDamagedPackagingPhotos);
  };

  return (
    <FullscreenModal>
      <div className="flex flex-col h-full">
        <StepHeader />

        <div className="flex-1 flex flex-col items-center pt-[120px]">
          <div className="flex flex-col items-center gap-4">
            <img
              src={checkPackagingIcon}
              alt="Check Contents"
              className="w-[168px] h-[168px]"
            />
            <div className="flex flex-col items-center gap-[6px]">
              <h1 className="text-[29px] font-bold text-white leading-[37px] tracking-[-0.01em]">
                Check Cardboard Box Damage
              </h1>
              <p className="text-[20px] font-medium text-[#C6CCE8] leading-[26px] text-center max-w-[600px]">
                Assess the cardboard box for damage.
              </p>
            </div>
          </div>
        </div>

        <WarehouseButtonsFooter>
          <WarehouseButtonGroup>
            <WarehouseButton variant="default" onClick={() => onCancel()}>
              Cancel
            </WarehouseButton>
            <WarehouseButton
              variant="reject"
              onClick={() => handleDamagedPackaging()}
            >
              Cardboard Box Damaged
            </WarehouseButton>
            <WarehouseButton variant="primary" onClick={() => next()}>
              No Damage, Continue
            </WarehouseButton>
          </WarehouseButtonGroup>
        </WarehouseButtonsFooter>
      </div>

      {showExitModal &&
        createPortal(
          <AnimatePresence>
            <ExitModal
              isOpen={showExitModal}
              onClose={() => setShowExitModal(false)}
              onConfirm={() => doExit()}
              title="Quit Processing Take Back"
              body="Are you sure you want to quit? All current processing for this take back will be lost."
              primaryText="Confirm"
              secondaryText="Back"
            />
          </AnimatePresence>,
          document.body
        )}
    </FullscreenModal>
  );
};

CheckPackaging.title = TITLE;
